import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['container', 'icon']
  
  scrollBottom() {
    const bottomOfPage = (document.documentElement.offsetHeight - window.pageYOffset - 1) < window.innerHeight
    const nextPageExists = this.page > 0
    
    if (bottomOfPage && nextPageExists) {
      this.incrementPage()
      this.appendNextPage()
    }
  }
  
  loadMore(event) {
    event.preventDefault()
    const nextPageExists = this.page > 0
    
    if (nextPageExists) {
      this.incrementPage()
      this.appendNextPage()
    } else {
      event.target.remove()
    }
  }
  
  incrementPage() {
    this.page++
  }
  
  appendNextPage() {
    this.showLoadingIcon()
    fetch(this.url, this.credentials)
          .then(response => response.text())
          .then(html => { html.length > 1 ? this.containerTarget.innerHTML += html : this.page = 0 })
          .then(response => this.hideLoadingIcon())
          .catch(response => console.warn(response))
  }
  
  showLoadingIcon() {
    this.iconTarget.classList.remove('invisible')
  }
  
  hideLoadingIcon() {
    this.iconTarget.classList.add('invisible')
  }
  
  // Private
  
    get page() {
      return this.data.get('page');
    }
    
    set page(value) {
      return this.data.set('page', value)
    }
    
    get url() {
      let url = this.data.get('url')
      if (url.indexOf("?") > -1) {
        return url + `&page=${this.page}`
      } else {
        return `${url}?page=${this.page}`
      }
    }
    
    get credentials() {
      return { credentials: "same-origin",
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': this.getMetaValue("csrf-token")
        },
      }
    }
    
    getMetaValue(name) {
      const element = document.head.querySelector(`meta[name="${name}"]`)
      return element.getAttribute("content")
    }
}